import { GAME_CONSTANTS } from '../config/gameConstants';

export const GAME_CONFIG = {
  STARTING_YEAR: GAME_CONSTANTS.time.startingDate.year,
  STARTING_MONTH: GAME_CONSTANTS.time.startingDate.month,
  STARTING_DAY: GAME_CONSTANTS.time.startingDate.day,
} as const;